/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */

import { getHttpService } from '../../../../../Services/http';
import { BaseServiceConfiguration } from '../../Base.service.config';

/**
 * Get the base service configuration.
 */
export const getBaseServiceConfig = (overrideSessionUrl?: string): BaseServiceConfiguration => {
  const httpService = getHttpService();
  const sessionUrl = overrideSessionUrl ?? (process.env.DXP_SERVICE_SESSION_API_URL as string);

  return {
    httpService,
    sessionUrl,
  };
};
